import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link, useLocation } from "react-router-dom";

const propTypes = {
  navPosition: PropTypes.string,
  hideNav: PropTypes.bool,
  hideSignin: PropTypes.bool,
  bottomOuterDivider: PropTypes.bool,
  bottomDivider: PropTypes.bool,
};

const defaultProps = {
  navPosition: "",
  hideNav: false,
  hideSignin: false,
  bottomOuterDivider: false,
  bottomDivider: false,
};

const isActivePath = (pathname, target) => {
  return pathname.endsWith(target);
};

const Header = ({
  className,
  navPosition,
  hideNav,
  hideSignin,
  bottomOuterDivider,
  bottomDivider,
  ...props
}) => {
  const [isActive, setIsactive] = useState(false);
  const location = useLocation();
  const nav = useRef(null);
  const hamburger = useRef(null);

  useEffect(() => {
    isActive && openMenu();
    document.addEventListener("keydown", keyPress);
    document.addEventListener("click", clickOutside);
    return () => {
      document.removeEventListener("keydown", keyPress);
      document.addEventListener("click", clickOutside);
      closeMenu();
    };
  });

  const openMenu = () => {
    document.body.classList.add("off-nav-is-active");
    nav.current.style.maxHeight = nav.current.scrollHeight + "px";
    setIsactive(true);
  };

  const closeMenu = () => {
    document.body.classList.remove("off-nav-is-active");
    nav.current && (nav.current.style.maxHeight = null);
    setIsactive(false);
  };

  const keyPress = (e) => {
    isActive && e.keyCode === 27 && closeMenu();
  };

  const clickOutside = (e) => {
    if (!nav.current) return;
    if (
      !isActive ||
      nav.current.contains(e.target) ||
      e.target === hamburger.current
    )
      return;
    closeMenu();
  };

  const classes = classNames(
    "site-header",
    bottomOuterDivider && "has-bottom-divider",
    className,
  );

  return (
    <header {...props} className={classes}>
      <div className="container">
        <div
          className={classNames(
            "site-header-inner",
            bottomDivider && "has-bottom-divider",
          )}
        >
          {/* <Logo /> */}
          {!hideNav && (
            <>
              <button
                ref={hamburger}
                className="header-nav-toggle"
                onClick={isActive ? closeMenu : openMenu}
              >
                <span className="screen-reader">Menu</span>
                <span className="hamburger">
                  <span className="hamburger-inner"></span>
                </span>
              </button>
              <nav
                ref={nav}
                className={classNames("header-nav", isActive && "is-active")}
              >
                <div className="header-nav-inner">
                  <ul
                    className={classNames(
                      "list-reset text-xs",
                      navPosition && `header-nav-${navPosition}`,
                    )}
                  >
                    <li>
                      <Link to="/" onClick={closeMenu}>
                        <span
                          style={
                            isActivePath(location.pathname, "/")
                              ? {
                                  textDecoration: "underline",
                                  textDecorationThickness: "2px",
                                  textUnderlineOffset: "4px",
                                }
                              : {}
                          }
                        >
                          Home
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/about" onClick={closeMenu}>
                        <span
                          style={
                            isActivePath(location.pathname, "/about")
                              ? {
                                  textDecoration: "underline",
                                  textDecorationThickness: "2px",
                                  textUnderlineOffset: "4px",
                                }
                              : {}
                          }
                        >
                          About
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/drives-score" onClick={closeMenu}>
                        <span
                          style={
                            isActivePath(location.pathname, "/drives-score")
                              ? {
                                  textDecoration: "underline",
                                  textDecorationThickness: "2px",
                                  textUnderlineOffset: "4px",
                                }
                              : {}
                          }
                        >
                          Drives Score
                          <span style={{ display: "inline-block" }}>
                            <sup
                              className="text-gold"
                              style={{
                                paddingLeft: "1px",
                                fontSize: "0.6em",
                                fontWeight: "bold",
                                verticalAlign: "super",
                              }}
                            >
                              TM
                            </sup>
                          </span>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/play">
                        <span
                          style={
                            isActivePath(location.pathname, "/play")
                              ? {
                                  textDecoration: "underline",
                                  textDecorationThickness: "2px",
                                  textUnderlineOffset: "4px",
                                }
                              : {}
                          }
                        >
                          Play
                        </span>
                      </Link>
                    </li>
                  </ul>
                  <ul className="list-reset header-nav-right"></ul>
                </div>
              </nav>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;
